import { LANGUAGE_SELECT_OPTIONS } from '@/services/languages/constants'
import { Language } from '@/services/languages/types'

type Option = { label: string; value: Language }

export function getLanguageOptions (langList: Language[]): Option[] {
  const languageSelectOptions = LANGUAGE_SELECT_OPTIONS.filter((lang) =>
    langList.includes(lang.value as Language),
  ) as Option[]
  return languageSelectOptions
}
